module.exports = __webpack_public_path__ + "img/Figure1_1.aa401376.jpg";